
const context = require.context('@', true, /\/zh-CN\/.*\.js$/)
const locales = context.keys().reduce((acc, key) => {
  const module = context(key)
  if (module && module.default) {
    return { ...acc, ...module.default }
  }
  return acc
}, {})

export default {
  'ec.global.title': '24小时政务服务智能助手',
  
  ...locales,
}
